import { get } from 'lodash';
import { retrieveDataMapper, retrieveObjectMapper } from '../..';

export const transformFetchExistingChild = (
  resp,
  childRelations,
  regChildParents
) => {
  const respChild = get(resp, 'data.child');
  const respMainApplicant = get(resp, 'data.main_applicant');
  const respRegParent = get(resp, 'data.reg_parent');
  const respRegChild = get(resp, 'data.reg_child');

  const childMapFields = [
    'ID:id',
    'firstname',
    'lastname',
    'birth_certificate',
    'date_of_birth',
  ];

  const mainApplicantMapFields = [
    'ID:id',
    'firstname',
    'lastname',
    'email',
    'mobile_phone_country_code',
    'mobile_phone',
    'workplace_staff',
    'identification_no',
  ];

  return {
    data: {
      getExistingChildV2: {
        child: respChild && {
          ...retrieveObjectMapper(respChild, childMapFields),
          childRelations: {
            data: childRelations.map(i =>
              retrieveObjectMapper(i, [
                'ID:id',
                'type:type_string',
                'fk_relation',
              ])
            ),
          },
        },
        mainApplicant:
          respMainApplicant &&
          retrieveObjectMapper(respMainApplicant, mainApplicantMapFields),
        regChild: respRegChild && {
          ...retrieveObjectMapper(respRegChild, childMapFields),
          registrationChildParents: {
            data: regChildParents.map(i =>
              retrieveObjectMapper(i, ['fk_relationship'])
            ),
          },
        },
        regParent:
          respRegParent &&
          retrieveObjectMapper(respRegParent, mainApplicantMapFields),
      },
    },
    success: true,
  };
};

export const transformRegistrationChild = (data = []) => ({
  data: data?.data?.map(item =>
    retrieveObjectMapper(item, [
      'ID:id',
      'firstname',
      'lastname',
      'fk_child',
      'birth_certificate',
    ])
  ),
  totalCount: data?.totalCount,
});

export const transformRegistrationById = (...args) => {
  const [
    resp,
    feeTier,
    form,
    centreByIds,
    addresses,
    programByIds,
    levelByIds,
    formParticipants,
    users,
    parents,
    regChild,
    regChildParents,
    mainApplicantAndSiblings,
    regParents,
    addressByRegParents,
    staffUser,
    regChildMappings,
    code,
  ] = args;

  return {
    success: true,
    data: {
      registrationByID: {
        ...retrieveObjectMapper(get(resp, 'data'), [
          'ID:id',
          'fk_user',
          'registration_start_date',
          'registration_deadline',
          'state',
          'consent_status:consent_status_string',
          'document_status:document_status_string',
          'created_at',
          'updated_at',
          'active',
          'payment_status:payment_status_string',
          'giro_status:giro_status_string',
          'show_noc',
          'is_application_submitted',
          'current_frontend_status',
          'document_notification_sent',
          'cancelled_by',
          'cancelled_at',
          'previous_frontend_status',
          'remarks',
          'type:type_string',
        ]),
        registrationChildMappings: {
          data: (regChildMappings || [])?.map(item => ({
            ...retrieveObjectMapper(item, [
              'ID:id',
              'fk_level',
              'fk_centre',
              'fk_program',
              'enrolment_date',
              'enquiry_date',
            ]),
            registrationChild: {
              ...retrieveObjectMapper(regChild, [
                'ID:id',
                'fk_child',
                'firstname',
                'lastname',
                'race',
                'nationality',
                'date_of_birth',
                'gender',
                'birth_certificate',
                'house_hold_income_range',
              ]),
              mainApplicant: retrieveObjectMapper(
                get(mainApplicantAndSiblings, 'mainApplicant', {}),
                [
                  'firstname',
                  'lastname',
                  'email',
                  'mobile_phone',
                  'mobile_phone_country_code',
                  'identification_no',
                  'workplace_staff',
                  'working_status',
                  'reason_of_unemployment',
                  'expected_delivery_date',
                ]
              ),
              siblings: {
                data: get(mainApplicantAndSiblings, 'siblings', [])?.map(m =>
                  retrieveObjectMapper(m, ['ID:id', 'firstname', 'lastname'])
                ),
              },
              registrationChildParents: {
                data: regChildParents.map(i => ({
                  ...retrieveObjectMapper(i, ['ID:id', 'fk_relationship']),
                  registrationParent: {
                    ...retrieveDataMapper(
                      regParents,
                      i.fk_registration_parent,
                      [
                        'ID:id',
                        'identification_no',
                        'workplace_staff',
                        'firstname',
                        'lastname',
                        'email',
                        'mobile_phone',
                        'mobile_phone_country_code',
                      ]
                    ),
                    addresses: (() => {
                      const addressByRegParent = addressByRegParents?.filter(
                        f =>
                          f.fk_registration_parent === i.fk_registration_parent
                      );

                      return {
                        totalCount: addressByRegParent?.length || 0,
                        data: addressByRegParent?.map(d =>
                          retrieveObjectMapper(d, [
                            'fk_user',
                            'address',
                            'building',
                            'floor',
                            'unit',
                            'city',
                            'country',
                            'postcode',
                          ])
                        ),
                      };
                    })(),
                  },
                })),
              },
            },
            level: retrieveDataMapper(levelByIds, item.fk_level, [
              'ID:id',
              'label',
            ]),
            centre: {
              ...retrieveDataMapper(centreByIds, item.fk_centre, [
                'ID:id',
                'label',
                'code',
                'payNowEmail',
              ]),
              addresses: (() => {
                const address = retrieveDataMapper(
                  addresses,
                  item.fk_centre,
                  [
                    'ID:id',
                    'name',
                    'postcode',
                    'fk_centre',
                    'lat',
                    'lng',
                    'building',
                    'floor',
                    'unit',
                    'city',
                  ],
                  'fk_centre'
                );
                if (address) {
                  return {
                    data: [address],
                    totalCount: 1,
                  };
                }
                return {
                  data: [],
                  totalCount: 0,
                };
              })(),
            },
            program: retrieveDataMapper(programByIds, item.fk_program, [
              'ID:id',
              'label',
            ]),
          })),
        },
        code: retrieveObjectMapper(code, ['description']),
        staff: staffUser?.staff
          ? {
              ID: get(staffUser, 'staff.id'),
              userByFkUser: {
                firstname: get(staffUser, 'user.firstname'),
                lastname: get(staffUser, 'user.lastname'),
              },
            }
          : null,
        forms: {
          data: get(form, 'data', [])?.map(r => ({
            ...retrieveObjectMapper(r, [
              'ID:id',
              'e_document_status:e_document_status_string',
              'fk_enquiry',
            ]),
            formParticipants: {
              data: get(
                retrieveDataMapper(formParticipants, r.id, ['data']),
                'data',
                []
              )?.map(p => ({
                ...retrieveObjectMapper(p, [
                  'ID:id',
                  'fk_form',
                  'display_name',
                  'order',
                  'email',
                  'status:status_string',
                  'updated_at',
                ]),
                parent: retrieveDataMapper(
                  parents,
                  p?.fk_parent || p?.fk_registration_parent,
                  ['firstname', 'lastname', 'mobile_phone']
                ),
                user: retrieveDataMapper(users, p.fk_user, [
                  'firstname',
                  'lastname',
                ]),
              })),
            },
          })),
        },
        feeTier: retrieveObjectMapper(feeTier, ['ID:id', 'label']),
      },
    },
  };
};

export const transformECDARegistrations = ({
  registrations = [],
  ecdaRegistrationChild = {},
  ecdaRegistrationParent = {},
  centres = [],
  levels = [],
  programs = [],
}) =>
  registrations?.map(reg => {
    const ecdaRegChildId = reg?.fk_ecda_registration_child;
    const ecdaRegChild = ecdaRegistrationChild?.[ecdaRegChildId];
    const fkEcdaRegParentId = reg?.fk_ecda_registration_parent;
    const ecdaRegParent = ecdaRegistrationParent?.[fkEcdaRegParentId];
    const centre = centres.find(({ id }) => id === reg?.fk_centre);
    const level = levels.find(({ id }) => id === reg?.fk_level);
    const program = programs.find(({ id }) => id === reg?.fk_program);
    const mainApplicant =
      ecdaRegParent?.type_string === 'applicant' ? ecdaRegParent : null;

    return {
      ...retrieveObjectMapper(reg, [
        'ID:id',
        'state:state_string',
        'created_at',
        'updated_at',
        'documentStatus:document_status_string',
        'paymentStatus:payment_status_string',
        'giroStatus:giro_status_string',
        'current_frontend_status',
        'previous_frontend_status',
        'enrolment_date',
        'enquiry_date',
      ]),
      ecdaRegistrationChild: ecdaRegChild && {
        ...retrieveObjectMapper(ecdaRegChild, [
          'ID:id',
          'fullname',
          'birth_certificate',
          'date_of_birth',
          'fk_child',
          'date_of_birth',
          'image_key',
          'image_key_presigned_url',
        ]),
        mainApplicant: retrieveObjectMapper(mainApplicant, [
          'ID:id',
          'fullname',
          'email',
          'mobile_phone',
          'mobile_phone_country_code',
          'fk_user',
        ]),
      },
      ecdaRegistrationParent: ecdaRegParent && {
        ...retrieveObjectMapper(ecdaRegParent, [
          'ID:id',
          'fullname',
          'email',
          'mobile_phone',
          'mobile_phone_country_code',
        ]),
        ecdaRegistrationChildParents: {
          data:
            ecdaRegParent?.ecdaRegistrationChildParents?.data?.map(item => ({
              ...retrieveObjectMapper(item, ['ID:id', 'fk_relationship']),
            })) || [],
        },
      },
      centre: centre && {
        ...retrieveObjectMapper(centre, ['ID:id', 'label', 'code', 'email']),
        addresses: {
          data:
            centre?.addresses?.data?.map(address => ({
              ...retrieveObjectMapper(address, [
                'ID:id',
                'address',
                'mobile_phone',
                'postcode',
              ]),
            })) || [],
        },
      },
      level: level && {
        ...retrieveObjectMapper(level, ['ID:id', 'label']),
      },
      program: program && {
        ...retrieveObjectMapper(program, ['ID:id', 'label']),
      },
    };
  }) || [];

export const transformECDAExistingParent = (data = {}, relation = '') => ({
  parent: data?.parent && {
    relation,
    ...retrieveObjectMapper(data?.parent, [
      'ID:id',
      'lastname',
      'firstname',
      'email',
      'mobile_phone',
      'mobile_phone_country_code',
      'workplace_staff',
      'gender',
      'identification_no',
      'nationality',
      'race',
      'monthly_income',
      'highest_qualification',
      'marital_status',
      'birthdate',
      'is_employed',
      'working_status',
      'occupational_title',
    ]),
  },
  ecdaRegParent: data?.ecda_reg_parent && {
    ...retrieveObjectMapper(data?.ecda_reg_parent, [
      'ID:id',
      'fullname',
      'email',
      'mobile_phone_country_code',
      'mobile_phone',
      'workplace_staff',
    ]),
  },
});

export const transformECDAExistingChild = ({
  data = {},
  childParents = [],
  childRelations = [],
}) => ({
  child: data?.child && {
    ...retrieveObjectMapper(data?.child, [
      'ID:id',
      'firstname',
      'lastname',
      'birth_certificate',
      'date_of_birth',
    ]),
    childRelations: {
      data: childRelations?.map(item => ({
        ...retrieveObjectMapper(item, [
          'ID:id',
          'type:type_string',
          'fk_relation',
        ]),
      })),
    },
  },
  ecdaRegChild: data?.ecda_reg_child && {
    ...retrieveObjectMapper(data?.ecda_reg_child, [
      'ID:id',
      'fullname',
      'birth_certificate',
      'date_of_birth',
    ]),
    ecdaRegistrationChildParents: {
      data: childParents?.map(item => ({
        ...retrieveObjectMapper(item, ['ID:id', 'fk_relationship']),
      })),
    },
  },
  ecdaRegParent: data?.ecda_reg_parent && {
    ...retrieveObjectMapper(data?.ecda_reg_parent, [
      'ID:id',
      'fullname',
      'email',
      'mobile_phone_country_code',
      'mobile_phone',
      'workplace_staff',
      'identification_no',
    ]),
  },
  mainApplicant: data?.main_applicant && {
    ...retrieveObjectMapper(data?.main_applicant, [
      'ID:id',
      'firstname',
      'lastname',
      'email',
      'mobile_phone_country_code',
      'mobile_phone',
      'workplace_staff',
      'identification_no',
    ]),
  },
});

export const transformECDARegParentInfo = (data = {}) => ({
  ecdaRegistrationParent:
    data?.ecda_registration_parent &&
    retrieveObjectMapper(data?.ecda_registration_parent, [
      'ID:id',
      'fk_parent',
      'fullname',
      'email',
      'mobile_phone_country_code',
      'mobile_phone',
      'date_of_birth',
      'identification_no',
      'nationality',
      'maritalStatus:marital_status_string',
      'fk_id_type',
      'workingStatus:working_status_string',
      'occupational_title',
      'occupational_remarks',
      'workplace_staff',
      'highest_education_level',
      'type_of_separation',
    ]),
  ecdaRegistrationChildParent:
    data?.ecda_registration_child_parent &&
    retrieveObjectMapper(data?.ecda_registration_child_parent, [
      'is_name_on_bc',
      'fk_relationship',
    ]),
  ecdaRegistrationParentGuardian:
    data?.ecda_registration_parent_guardian &&
    retrieveObjectMapper(data?.ecda_registration_parent_guardian, [
      'fullname',
      'relationship',
      'dateOfBirth',
      'nationality',
      'identification_no',
    ]),
  address:
    data?.address &&
    retrieveObjectMapper(data?.address, [
      'address',
      'building',
      'floor',
      'unit',
      'postcode',
      'name',
      'city',
      'country',
    ]),
});

export const transformMedicalConditions = (data = {}) => ({
  medicalConditionRemarks: data?.medicalConditionRemarks,
  medicalConditions:
    data?.medicalConditions?.map(item => ({
      ...retrieveObjectMapper(item, ['disease', 'exists', 'remarks']),
    })) || [],
});

export const transformEnrolmentForm = (data = {}) => ({
  allowedSteps: data?.allowed_steps || [],
  isParentConsented: data?.is_parent_consented,
  marketingChannels:
    data?.marketing_channels &&
    retrieveObjectMapper(data?.marketing_channels, [
      'IsEmail:is_email',
      'IsPhone:is_phone',
      'IsSMS:is_sms',
    ]),
  ecdaRegistration: data?.ecda_registration && {
    ...retrieveObjectMapper(data?.ecda_registration, [
      'ID:id',
      'fk_lead',
      'fk_user',
      'fk_ecda_registration_parent',
      'fk_ecda_registration_child',
      'fk_transfer_draft',
      'fk_centre',
      'fk_level',
      'fk_program',
      'enrolment_date',
      'enquiry_date',
      'state',
      'mandatory_form_step',
      'supplementary_form_step',
      'documentStatus:document_status_string',
      'giroStatus:giro_status_string',
      'paymentStatus:payment_status_string',
      'registration_start_date',
      'registration_deadline',
      'type:type_string',
      'is_application_submitted',
      'is_reapplication',
      'tc_acknowledge_by',
      'tc_document_url',
      'tc_document_download_url', // missing field
      'sug_acknowledge_by',
      'marketing_consent_by',
      'snapshot',
      'fk_cancel_code',
      'remarks',
      'is_cancelled',
      'cancelled_by',
      'cancelled_at',
      'document_notification_sent',
      'active',
      'created_at',
      'updated_at',
      'current_frontend_status', // missing field
      'previous_frontend_status', // missing field
    ]),
    userByTcAcknowledgeBy: {}, // missing subquery
  },
  child:
    data?.child &&
    retrieveObjectMapper(data?.child, [
      'ID:id',
      'fk_child',
      'fullname',
      'race',
      'nationality',
      'gender',
      'date_of_birth',
      'fk_id_type',
      'image_key',
      'birth_certificate',
      'num_family_members',
      'household_income_range',
      'type_of_referral',
      'co_payment_amount',
      'apply_for_sug',
      'has_emergency_contact',
      'overwrite_second_applicant',
      'child_hubspot_id',
      'active',
      'shadow_active',
      'created_at',
      'updated_at',
    ]),
  mainApplicant: data?.main_applicant && {
    ...transformECDARegParentInfo(data?.main_applicant || {}),
  },
  spouse: data?.spouse && {
    ...transformECDARegParentInfo(data?.spouse || {}),
  },
  emergencyContactInfo: data?.emergency_contact_info && {
    ...retrieveObjectMapper(data?.emergency_contact_info, [
      'firstName',
      'lastName',
      'email',
      'relationship',
      'identificationNo',
      'postalCode',
      'address',
      'floorNo',
      'unitNo',
      'blockNo',
      'mobilePhone',
      'mobilePhoneCC',
    ]),
  },
  healthInfo: data?.health_info && {
    immunizations: data?.health_info?.immunizations && {
      isImmunized: data?.health_info?.immunizations?.isImmunized,
      immunizationDetails:
        data?.health_info?.immunizations?.immunizationDetails?.map(item => ({
          ...retrieveObjectMapper(item, ['disease', 'exists', 'remarks']),
        })) || [],
    },
    familyDoctorDetails:
      data?.health_info?.familyDoctorDetails &&
      retrieveObjectMapper(data?.health_info?.familyDoctorDetails, [
        'name',
        'email',
        'contactNumber',
        'countryCode',
        'clinicName',
        'clinicPostalCode',
        'clinicBuilding',
        'clinicCity',
        'clinicFloor',
        'clinicUnit',
        'clinicCountry',
        'clinicBlockNo',
        'remarks',
      ]),
    physicalConditions: data?.health_info?.physicalConditions && {
      ...transformMedicalConditions(data?.health_info?.physicalConditions),
    },
    nonFoodAllergies: data?.health_info?.nonFoodAllergies && {
      ...transformMedicalConditions(data?.health_info?.nonFoodAllergies),
    },
    foodAllergies: data?.health_info?.foodAllergies && {
      ...transformMedicalConditions(data?.health_info?.foodAllergies),
    },
    specialNeeds: data?.health_info?.specialNeeds && {
      ...transformMedicalConditions(data?.health_info?.specialNeeds),
    },
    userByUpdatedBy: data?.health_info?.userByUpdatedBy && {
      ID: data?.health_info?.userByUpdatedBy?.id,
    },
    updatedAt: data?.health_info?.updatedAt,
  },
});

export const transformMsFetchEnquiryDataByIdECDAMVP = ({
  enquiryData = {},
  centreByIds,
  address = {},
  programByIds = [],
  levelByIds = [],
  ecdaParentRegistrationData = {},
  ecdaChildParentByEcdaIdsData = {},
  ecdaChildRegistration,
  sibilingsData = [],
  leadData = {},
  userAcknowledgeData = {},
  ackUserData = {},
  childData = {},
  userData = {},
}) => ({
  ecdaRegistrationByID: {
    ...retrieveObjectMapper(enquiryData?.data, [
      'ID:id',
      'fk_user',
      'registration_start_date',
      'registration_deadline',
      'current_frontend_status',
      'previous_frontend_status',
      'state:state_string',
      'documentStatus:document_status_string',
      'created_at',
      'updated_at',
      'active',
      'paymentStatus:payment_status_string',
      'giroStatus:giro_status_string',
      'is_application_submitted',
      'document_notification_sent',
      'cancelled_by',
      'cancelled_at',
      'fk_cancel_code',
      'remarks',
      'type:type_string',
      'registration_start_date',
      'enrolment_date',
      'enquiry_date',
      'tc_acknowledge_by',
      'tcDocumentURL:tc_document_url',
      'tcDocumentDownloadURL:tc_document_url_presigned_url',
      'marketing_consent_by',
      'exceeding_cap',
    ]),
    centre: {
      ...retrieveObjectMapper(centreByIds[0], [
        'ID:id',
        'label',
        'code',
        'payNowEmail',
      ]),
      addresses: {
        totalCount: 1,
        data: {
          ...retrieveObjectMapper(address, [
            'ID:id',
            'name',
            'address',
            'postcode',
            'fk_centre',
            'lat',
            'lng',
            'building',
            'floor',
            'unit',
            'city',
          ]),
        },
      },
    },
    program: retrieveObjectMapper(programByIds[0], ['ID:id', 'label']),
    level: retrieveObjectMapper(levelByIds[0], ['ID:id', 'label']),
    ecdaRegistrationParent: {
      ...retrieveObjectMapper(ecdaParentRegistrationData, [
        'fullname',
        'mobile_phone',
        'mobile_phone_country_code',
        'email',
        'workplaceStaff:workplace_staff',
      ]),
      ecdaRegistrationChildParents: {
        data: ecdaChildParentByEcdaIdsData?.data?.map(item => {
          return {
            fkRelationship: get(item, 'fk_relationship'),
          };
        }),
      },
    },
    ecdaRegistrationChild: {
      ...retrieveObjectMapper(ecdaChildRegistration, [
        'fullname',
        'ID:id',
        'fk_child',
        'race',
        'nationality',
        'gender',
        'date_of_birth',
        'image_key',
        'birth_certificate',
        'num_family_members',
        'household_income_range',
      ]),
      siblings: {
        data:
          get(sibilingsData, 'length', 0) > 0 &&
          sibilingsData.map(item => {
            return {
              ID: get(item, 'id'),
              firstname: get(item, 'data.firstname'),
              lastname: get(item, 'data.lastname'),
            };
          }),
      },
    },
    lead: {
      hubspotEnquiryID: get(leadData, 'data.hubspot_enquiry_id'),
    },
    userByTcAcknowledgeBy: {
      isParent: get(userAcknowledgeData, 'is_parent'),
      ecdaRegistrationParentsByFkUser: {
        totalCount: get(ackUserData, 'data.totalCount'),
      },
    },
    feeTier: {
      ID: get(childData, 'data.id'),
      label: get(childData, 'data.label'),
    },
    staff: {
      ID: get(enquiryData, 'data.cancelled_by'),
      userByFkUser: {
        firstname: get(userData, 'firstname'),
        lastname: get(userData, 'lastname'),
      },
    },
  },
});
export const transformGetRegistrations = (
  resp,
  regChildMappings = {},
  reqChildren = {},
  centres = {},
  programs = {},
  levels = {},
  applicants = {},
  regParents = {}
) => {
  return {
    success: true,
    data: {
      getRegistrations: {
        totalCount: get(resp, 'data.total_count', 0),
        data: (get(resp, 'data.data') || [])?.map(item => ({
          ...retrieveObjectMapper(item, [
            'ID:id',
            'current_frontend_status',
            'state',
            'created_at',
            'updated_at',
          ]),
          registrationChildMappings: {
            data: (
              retrieveDataMapper(regChildMappings, item.id, ['data'])?.data ||
              []
            )?.map(regChildMapping => ({
              ...retrieveObjectMapper(regChildMapping, [
                'ID:id',
                'enrolment_date',
              ]),
              registrationChild: {
                ...retrieveDataMapper(
                  reqChildren,
                  regChildMapping.fk_registration_child,
                  [
                    'ID:id',
                    'fk_child',
                    'lastname',
                    'firstname',
                    'birth_certificate',
                    'date_of_birth',
                    'image_key',
                    'imageKeyPresignedURL:image_key_presigned_url',
                  ]
                ),
                mainApplicant: retrieveDataMapper(
                  applicants,
                  regChildMapping?.fk_registration_child,
                  [
                    'firstname',
                    'lastname',
                    'email',
                    'mobile_phone_country_code',
                    'mobile_phone',
                    'identification_no',
                  ]
                ),
                registrationChildParents: {
                  data: (
                    retrieveDataMapper(
                      regParents,
                      regChildMapping?.fk_registration_child,
                      ['data']
                    )?.data || []
                  )?.map(regParent => ({
                    ID: regParent?.id,
                    registrationParent: retrieveObjectMapper(regParent, [
                      'firstname',
                      'lastname',
                      'email',
                      'mobile_phone_country_code',
                      'mobile_phone',
                    ]),
                  })),
                },
              },
              centre: retrieveDataMapper(centres, regChildMapping?.fk_centre, [
                'code',
                'label',
              ]),
              level: retrieveDataMapper(levels, regChildMapping?.fk_level, [
                'label',
              ]),
              program: retrieveDataMapper(
                programs,
                regChildMapping?.fk_program,
                ['label']
              ),
            })),
          },
        })),
      },
    },
  };
};

export const transformGetECDARegUploadDocumentList = (
  resp,
  documentTypeConfigs,
  ecdaRegChildren,
  ecdaRegParents,
  ecdaRegParentAttributes,
  documentTags,
  documents,
  users
) => {
  return {
    success: true,
    data: {
      getRequiredECDARegDocuments: {
        data: (resp?.data || [])?.map(item => ({
          ...retrieveObjectMapper(item, [
            'ID:id',
            'status:status_string',
            'remarks',
            'reviewed_by',
            'updated_at',
            'label',
            'for_staff_only',
            'fk_ecda_registration_child',
            'fk_ecda_registration_parent',
          ]),
          documentTypeConfig: retrieveDataMapper(
            documentTypeConfigs,
            item?.fk_document_type_config,
            ['label', 'description', 'code']
          ),
          ecdaRegistrationChild: retrieveDataMapper(
            ecdaRegChildren,
            item?.fk_ecda_registration_child,
            ['fullname', 'birth_certificate']
          ),
          ecdaRegistrationParent: (() => {
            if (item?.fk_ecda_registration_parent) {
              return {
                ...retrieveDataMapper(
                  ecdaRegParents,
                  item?.fk_ecda_registration_parent,
                  ['fullname', 'identification_no']
                ),
                ecdaRegistrationParentAttributes: {
                  data: (
                    get(
                      retrieveDataMapper(
                        ecdaRegParentAttributes,
                        item?.fk_ecda_registration_parent,
                        ['data']
                      ),
                      'data'
                    ) || []
                  )?.map(attr => retrieveObjectMapper(attr, ['value'])),
                },
              };
            }
            return null;
          })(),
          documentTags: {
            // TODO: double check the API by document type or document type config
            data: (
              get(
                retrieveDataMapper(
                  documentTags,
                  item?.fk_document_type_config,
                  ['data']
                ),
                'data'
              ) || []
            )?.map(tag => ({
              ...retrieveObjectMapper(tag, ['ID:id']),
              document: (() => {
                const doc = retrieveDataMapper(documents, tag?.fk_document, [
                  'ID:id',
                  'filename',
                  'updated_at',
                  'uRL:url',
                  'preSignedUrl:url_presigned_url',
                  'uploaded_by',
                ]);
                if (!doc) return null;
                return {
                  ...doc,
                  user: retrieveDataMapper(users, doc?.uploadedBy, [
                    'ID:id',
                    'firstname',
                    'lastname',
                  ]),
                };
              })(),
            })),
          },
        })),
        totalCount: resp?.totalCount || 0,
      },
    },
  };
};

export const transformExistingParent = (resp = {}) => {
  return {
    success: true,
    data: {
      getExistingParent: {
        parent: retrieveObjectMapper(get(resp, 'data.parent', {}), [
          'ID:id',
          'lastname',
          'firstname',
          'email',
          'mobile_phone_country_code',
          'mobile_phone',
          'workplace_staff',
          'gender',
          'identification_no',
          'nationality',
          'race',
          'monthly_income',
          'highest_qualification',
          'marital_status',
          'birthdate',
          'is_employed',
          'relation',
          'working_status',
          'occupational_title',
        ]),
        regParent: retrieveObjectMapper(get(resp, 'data.reg_parent', {}), [
          'ID:id',
          'lastname',
          'firstname',
          'email',
          'mobile_phone_country_code',
          'mobile_phone',
          'workplace_staff',
        ]),
      },
    },
  };
};

export const transformRegistrationInvoice = (
  resp = {},
  invoiceId,
  invoiceItems = {},
  billableItems = {},
  receipts = {},
  staffUsers = {}
) => {
  return {
    success: true,
    data: {
      getRegistrationInvoice: {
        ...retrieveObjectMapper(resp?.data, [
          'ID:id',
          'total_amount',
          'outstanding_amount',
          'invoice_no',
          'invoice_date',
          'invoice_due_date',
          'status:status_string',
          'invoice_type:invoice_type_string',
          'grand_total',
          'updated_at',
          'sn1_updated_by',
          'sn1_verified_by',
        ]),
        invoiceItems: {
          data: (get(invoiceItems, 'data.data') || []).map(invoiceItem => ({
            ...retrieveObjectMapper(invoiceItem, [
              'ID:id',
              'label',
              'total_amount',
              'display_total_amount',
              'display_adjusted_amount', // missing,
            ]),
            billableItem: retrieveDataMapper(
              billableItems,
              invoiceItem?.fk_billable_item,
              ['sn1_str_acc_pac_account_code']
            ),
          })),
        },
        receipts: {
          data: (get(receipts, `${invoiceId}`) || []).map(receipt => ({
            ...retrieveObjectMapper(receipt, [
              'receipt_no',
              'payment_type',
              'amount',
              'amount_received',
              'created_at',
              'updated_at',
              'document_no',
            ]),
            userByCollectedByFkStaff: retrieveObjectMapper(
              get(
                staffUsers,
                `${receipt?.collected_by_fk_staff}.data[0].user`,
                {}
              ),
              ['firstname', 'lastname']
            ),
          })),
        },
      },
    },
  };
};

export const transformFormSigners = (formSigners = []) => {
  return formSigners.map(signer =>
    retrieveObjectMapper(signer, [
      'DisplayName:display_name',
      'Email:email',
      'Order:order',
      'ParentID:reg_parent_id',
      'UserId:user_id',
      'Status:status',
      'IsStaff:is_staff',
      'Type:type',
      'UpdatedAt:updated_at',
    ])
  );
};
